import React from 'react';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import { getStringFromLS } from '../../helper-utils/localStorage';
import { APP_LOADER_URL } from '../../../saas/AppStorageStaticNames';

function AppLoading({ isLoading }) {
  return (
    <Modal
      centered
      show={isLoading}
      size="sm"
      backdrop="static"
      keyboard={false}
      dialogClassName="modal-90w d-flex justify-content-center app-loading"
      aria-labelledby="API request going. Waiting for response"
    >
      <Modal.Body className="p-0 d-flex justify-content-center align-items-center">
        <img
          style={{ width: '300px' }}
          src={getStringFromLS(APP_LOADER_URL)}
          alt="Please wait"
        />
      </Modal.Body>
    </Modal>
  );
}

AppLoading.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};

export default AppLoading;
